import { Component } from 'react';
import PropTypes from 'prop-types';

import { ChildrenProp } from '../../shared/utils/prop-types/prop-types';

class ErrorBoundary extends Component {
  static propTypes = {
    children: ChildrenProp,
    name: PropTypes.string.isRequired,
    renderError: PropTypes.func.isRequired
  };

  state = { error: null, hasError: false };

  static getDerivedStateFromError(error) {
    return { error, hasError: true };
  }

  componentDidCatch(error) {
    const { name } = this.props;
    // TODO: Use error logging service to track errors
    console.error(`${name} error | ${error}`);
  }

  render() {
    const { error, hasError } = this.state;
    const { children, renderError } = this.props;

    if (hasError && typeof renderError === 'function') {
      return renderError(error);
    }

    return children;
  }
}

export default ErrorBoundary;
